import { useEffect } from 'react';
import logger from 'lc-logger';
import appConfig from 'lc-app-config';
import ResourceCenterService from '../../services/resource-center';
import BlogPost from '../../components/blogPost/blogPost';
import {
  getStructuredFieldsFromUrl,
  errorFilter,
  validCMSUrl,
  getOptimizelyUserExperiments,
} from '../../services/helpers/common';
import styles from '../../styles/main.module.scss';
import XrayMode from '../../components/xrayMode/xrayMode';
import render404Page from '../../services/helpers/render404Page';
import trackHeapEvent from '../../services/helpers/trackHeapEvent';
import csrf from '../../services/helpers/csrf';

export default function Post({
  blogPost,
  isPreview = false,
  spaceId,
  entryId,
  experiments,
}) {
  useEffect(() => {
    trackHeapEvent(
      {
        Title: 'Page Load',
        Page: `Resource Center - ${blogPost.singlePost.title}`,
      },
      `CMS_Unification`,
      experiments
    );
  }, [blogPost, experiments]);
  return (
    <main className={styles.main}>
      {isPreview && spaceId && (
        <XrayMode
          title={blogPost.singlePost.title ?? 'Content'}
          spaceId={spaceId}
          entryId={entryId}
        />
      )}
      <BlogPost {...blogPost} backLink="/resource-center" />
    </main>
  );
}

export async function getServerSideProps(context) {
  const resourceCenterService = new ResourceCenterService(context.preview);

  const fieldsFromUrl = getStructuredFieldsFromUrl(context.resolvedUrl);
  const logAttributes = {
    hub: fieldsFromUrl['fields.hub'],
    product: fieldsFromUrl['fields.product'],
    slug: fieldsFromUrl['fields.slug'],
  };
  if (!validCMSUrl(logAttributes.slug)) {
    logger.info(
      { ...{ statusCode: 404 }, ...logAttributes },
      'LC-WEBSITE: Invalid slug request'
    );
    return {
      notFound: true,
    };
  }
  const userVariation = getOptimizelyUserExperiments(context.req.headers);
  const props = await resourceCenterService.getPostPage(
    fieldsFromUrl,
    userVariation
  );
  if (!props) {
    logger.info(
      { ...{ statusCode: 404 }, ...logAttributes },
      'LC-WEBSITE: Page not found for Slug'
    );
    return render404Page(context);
  }
  logger.info(
    { ...{ statusCode: 200 }, ...logAttributes },
    'LC-WEBSITE: Generating page for Slug'
  );

  const spaceId = appConfig.get('CONTENTFUL_SPACE_ID');
  let csrfToken = '';
  try {
    csrfToken = await csrf(context.req, context.res);
  } catch (err) {
    logger.info(
      { ...logAttributes },
      'LC-WEBSITE: Error in generating csrf. Error: ',
      errorFilter(err)
    );
  }

  return {
    props: {
      ...props,
      isPreview: !!context.preview,
      spaceId,
      csrfToken,
      experiments: Object.fromEntries(userVariation),
    },
  };
}
